import { Link } from 'react-router-dom';
import { Code2, FileText, Video, Wrench } from 'lucide-react';

export default function Home() {
  const features = [
    {
      icon: FileText,
      title: 'Resume',
      description: 'View my professional experience, skills, and achievements',
      href: '/me',
    },
    {
      icon: Wrench,
      title: 'Developer Tools',
      description: 'Free, open-source tools for developers',
      href: '/dev-tools/json-formatter',
    },
    {
      icon: Video,
      title: 'Meet Me',
      description: 'Schedule a video call using Cloudflare RealtimeKit',
      href: '/meet-me',
    },
    {
      icon: Code2,
      title: 'Blog',
      description: 'Technical articles and insights',
      href: '/blog',
    },
  ];

  return (
    <div className="container py-16">
      {/* Hero Section */}
      <div className="mb-16 text-center">
        <h1 className="mb-4 text-5xl font-bold text-gray-900 dark:text-gray-100 sm:text-6xl">
          Hi, I&apos;m Ravindra Singh Rathor
        </h1>
        <p className="mx-auto max-w-2xl text-xl text-gray-600 dark:text-gray-400">
          Senior Software Engineer & Tech Lead specializing in distributed systems across Ed-Tech, Fin-Tech, and SDK development.
        </p>
      </div>

      {/* Features Grid */}
      <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
        {features.map(feature => (
          <Link
            key={feature.title}
            to={feature.href}
            className="card group transition-all hover:shadow-md"
          >
            <feature.icon className="mb-4 h-10 w-10 text-primary-600 dark:text-primary-400 transition-transform group-hover:scale-110" />
            <h3 className="mb-2 text-lg font-semibold text-gray-900 dark:text-gray-100">{feature.title}</h3>
            <p className="text-sm text-gray-600 dark:text-gray-400">{feature.description}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}
